#import "../workOrder/workOrderInfo.gql"
#import "../line/lineInfo.gql"

fragment workBlockInfo on WorkBlock {
  effectiveLabor
  endsAt
  id
  productionRateOverride
  performanceOverride
  efficiencyOverride
  laborOverride
  lockedOnSchedule
  jobId
  productionRateDependsOnNumberOfPeople
  quantity
  standardPeople
  standardProductionRate
  performance
  startsAt
  teardownTimeLabel
  teardownTimeDuration
  unitOfMeasure
  lineEfficiency
  line {
    ...lineInfo
  }
  overlappingPlannedBreaks {
    plannedBreakName
    duration
  }
  workOrder {
    code
    completed
    customerName
    customWorkOrderFieldSelections {
      id
      customWorkOrderField {
        id
        label
      }
      customWorkOrderFieldValue {
        id
        description
        indicator
      }
    }
    description
    due
    endAt
    externalId
    externalUuid
    flag
    id
    missingData
    itemCode
    itemDescription
    materialAvailabilityDate
    notes
    pastDue
    performance
    productionRateDependsOnNumberOfPeople
    quantity
    producedQuantity
    productionLastUpdatedAt
    remainingDuration
    requiredDuration
    schedulable
    scheduledDuration
    scheduledQuantity
    scheduledStatus
    standardPeople
    standardProductionRate
    startAt
    status
    unitOfMeasure
    unschedulable
    unscheduledQuantity
    lineTypePreferencePrimary
    lineTypePreferenceSecondary
  }
  workTimeEndsAt
  workTimeStartsAt
}
